import axios from 'axios'

const instance = axios.create({
  baseURL: process.env.NODE_ENV==='development'? 
  'http://localhost:4000/':
  'http://tstatsapi.stats-insight.com/'
})

export const api_getFilterResult = async (payload) => {
  console.log('Get Filter Result')
  try {
    const { data } = await instance.post('ballsStat/abl/getFilterResult', payload)
    if (data.status !== undefined) throw Error(data.message)
    return { status: 'success', data }
  } catch (err) {
    return { status: 'error', message: err.message }
  }
}

export const api_getFilterLeagueData = async () => {
  console.log('Get Filter League Data')
  try {
    const data = await instance.get('ballsStat/getFilterLeagueData')
    if (data.status === undefined) throw Error(data.message)
    return { status: 'success', data: data.data }
  } catch (err) {
    return { status: 'error', message: err.message }
  }
}

export const api_getPitcherLeaderboardData = async (payload) => {
  console.log('Get Pitcher Leaderboard')
  try {
    const { data } = await instance.post('/lead/getPitcherLeaderBoardData', payload)
    if (data.status !== undefined) throw Error(data.message)
    return { status: 'success', data }
  } catch (err) {
    return { status: 'error', message: err.message }
  }
}

export const api_getBatterLeaderboardData = async (payload) => {
  console.log('Get Batter Leaderboard')
  try {
    const { data } = await instance.post('/lead/getBatterLeaderBoardData', payload)
    if (data.status !== undefined) throw Error(data.message)
    return { status: 'success', data }
  } catch (err) {
    return { status: 'error', message: err.message }
  }
}

export const api_getTeamBattingLeaderboardData = async (payload) => {
  console.log('Get Team Batting Leaderboard')
  try {
    const { data } = await instance.post('/lead/getTeamBattingLeaderBoardData', payload)
    if (data.status !== undefined) throw Error(data.message)
    return { status: 'success', data }
  } catch (err) {
    return { status: 'error', message: err.message }
  }
}

export const api_getTeamPitchingLeaderboardData = async (payload) => {
  console.log('Get Team Pitching Leaderboard')
  try {
    const { data } = await instance.post('/lead/getTeamPitchingLeaderBoardData', payload)
    if (data.status !== undefined) throw Error(data.message)
    return { status: 'success', data }
  } catch (err) {
    return { status: 'error', message: err.message }
  }
}

export const api_get2021SinglePlayerStat = async (payload) => {
  console.log('Get 2021 Single Player BallsStat')
  try {
    const { data } = await instance.post('/ballsStat/get2021SinglePlayerStat', payload)
    if (data.status !== undefined) throw Error(data.message)
    return { status: 'success', data }
  } catch (err) {
    return { status: 'error', message: err.message }
  }
}

export const api_get2022SinglePlayerStat = async (payload) => {
  console.log('Get 2022 Single Player BallsStat')
  try {
    const { data } = await instance.post('/ballsStat/get2022SinglePlayerStat', payload)
    if (data.status !== undefined) throw Error(data.message)
    return { status: 'success', data }
  } catch (err) {
    return { status: 'error', message: err.message }
  }
}

export const api_getPitcherPR = async (payload) => {
  console.log('Get Pitcher PR')
  try {
    const { data } = await instance.post('/pr/getPitcherPRData', payload)
    if (data.status !== undefined) throw Error(data.message)
    return { status: 'success', data }
  } catch (err) {
    return { status: 'error', message: err.message }
  }
}

export const api_getBatterPR = async (payload) => {
  console.log('Get Batter PR')
  try {
    const { data } = await instance.post('/pr/getBatterPRData', payload)
    if (data.status !== undefined) throw Error(data.message)
    return { status: 'success', data }
  } catch (err) {
    return { status: 'error', message: err.message }
  }
}

export const api_getPitcherStat = async (payload) => {
  console.log('Get Pitcher Stat')
  try {
    const { data } = await instance.post('/stat/getPitcherStat', payload)
    if (data.status !== undefined) throw Error(data.message)
    return { status: 'success', data }
  } catch (err) {
    return { status: 'error', message: err.message }
  }
}

export const api_getBatterStat = async (payload) => {
  console.log('Get Batter Stat')
  try {
    const { data } = await instance.post('/stat/getBatterStat', payload)
    if (data.status !== undefined) throw Error(data.message)
    return { status: 'success', data }
  } catch (err) {
    return { status: 'error', message: err.message }
  }
}

export const api_getReportData = async (dest) => {
  console.log('Get Report Data')
  try {
    const { data } = await instance.get(`/report/${dest}`)
    if (data.status !== undefined) throw Error(data.message)
    return { status: 'success', data }
  } catch (err) {
    return { status: 'error', message: err.message }
  }
}

export const api_getBatterScoreLogs = async (payload) => {
  console.log('Get Batter Score Logs')
  try {
    const { data } = await instance.post('/stat/getBatterScoreLogs', payload)
    if (data.status !== undefined) throw Error(data.message)
    return { status: 'success', data }
  } catch (err) {
    return { status: 'error', message: err.message }
  }
}

export const api_getVideoSignedURL = async (payload) => {
  console.log('Get Video URL')
  try {
    const { data: { url } } = await instance.post('/video/getVideoURL', payload)
    console.log("url:", url)
    return url
  } catch (err) {
    return { status: 'error', message: err.message }
  }
}